<div
  *ngIf="services$ | async as services; else loading"
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="12px"
>
  <div *ngIf="services.length === 0">
    <div class="no-conversations">You have no conversations.</div>
    <div class="no-conversations">
      Contact a service provider with the <strong>'Contact'</strong> button on
      the Find Services page.
    </div>
  </div>
  <app-service-contact-listing
    *ngFor="let service of services"
    [service]="service"
  >
  </app-service-contact-listing>
</div>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
